/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddAdhocContactRequest,
  AddAdhocContactResponse,
  AdhocContactsResponse,
  BasicClaimInfo,
  BillingRolesResponse,
  ClaimFinancialSummary,
  ClaimImportantDates,
  ClaimPresentPositions,
  ClaimResponse,
  ClaimSearchResult,
  ClaimSummary,
  ClaimTasksResponse,
  ClientBrokerDetailsResponse,
  CreateCaseNoteRequest,
  CreateCaseNoteResponse,
  CreateTimeEntryRequest,
  CreateTimeEntryResponse,
  DocumentInfo,
  LabourCodesResponse,
  ParticipantsResponse,
  ProblemDetails,
  RepliconUserStatusResponse,
  SiteVisitDetailsResponse,
  TimeEntryStatusesResponse,
  UpdatePresentPositionRequest,
  UpdatePresentPositionResponse,
  UpdateTaskRequest,
  UpdateTaskResponse,
  WorkPackagesResponse,
} from '../models/index';
import {
    AddAdhocContactRequestFromJSON,
    AddAdhocContactRequestToJSON,
    AddAdhocContactResponseFromJSON,
    AddAdhocContactResponseToJSON,
    AdhocContactsResponseFromJSON,
    AdhocContactsResponseToJSON,
    BasicClaimInfoFromJSON,
    BasicClaimInfoToJSON,
    BillingRolesResponseFromJSON,
    BillingRolesResponseToJSON,
    ClaimFinancialSummaryFromJSON,
    ClaimFinancialSummaryToJSON,
    ClaimImportantDatesFromJSON,
    ClaimImportantDatesToJSON,
    ClaimPresentPositionsFromJSON,
    ClaimPresentPositionsToJSON,
    ClaimResponseFromJSON,
    ClaimResponseToJSON,
    ClaimSearchResultFromJSON,
    ClaimSearchResultToJSON,
    ClaimSummaryFromJSON,
    ClaimSummaryToJSON,
    ClaimTasksResponseFromJSON,
    ClaimTasksResponseToJSON,
    ClientBrokerDetailsResponseFromJSON,
    ClientBrokerDetailsResponseToJSON,
    CreateCaseNoteRequestFromJSON,
    CreateCaseNoteRequestToJSON,
    CreateCaseNoteResponseFromJSON,
    CreateCaseNoteResponseToJSON,
    CreateTimeEntryRequestFromJSON,
    CreateTimeEntryRequestToJSON,
    CreateTimeEntryResponseFromJSON,
    CreateTimeEntryResponseToJSON,
    DocumentInfoFromJSON,
    DocumentInfoToJSON,
    LabourCodesResponseFromJSON,
    LabourCodesResponseToJSON,
    ParticipantsResponseFromJSON,
    ParticipantsResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RepliconUserStatusResponseFromJSON,
    RepliconUserStatusResponseToJSON,
    SiteVisitDetailsResponseFromJSON,
    SiteVisitDetailsResponseToJSON,
    TimeEntryStatusesResponseFromJSON,
    TimeEntryStatusesResponseToJSON,
    UpdatePresentPositionRequestFromJSON,
    UpdatePresentPositionRequestToJSON,
    UpdatePresentPositionResponseFromJSON,
    UpdatePresentPositionResponseToJSON,
    UpdateTaskRequestFromJSON,
    UpdateTaskRequestToJSON,
    UpdateTaskResponseFromJSON,
    UpdateTaskResponseToJSON,
    WorkPackagesResponseFromJSON,
    WorkPackagesResponseToJSON,
} from '../models/index';

export interface AddClaimAdhocContactRequest {
    claimNumber: string;
    addAdhocContactRequest: AddAdhocContactRequest;
}

export interface ClaimExistsRequest {
    claimNumber: string;
}

export interface CreateClaimTimeEntryRequest {
    claimNumber: string;
    createTimeEntryRequest: CreateTimeEntryRequest;
}

export interface CreateFileNoteCaseNoteRequest {
    claimNumber: string;
    createCaseNoteRequest: CreateCaseNoteRequest;
}

export interface GetBasicClaimInfoRequest {
    claimNumber: string;
}

export interface GetClaimRequest {
    claimNumber: string;
}

export interface GetClaimAdhocContactsRequest {
    claimNumber: string;
}

export interface GetClaimBillingRolesRequest {
    claimNumber: string;
    date: Date;
}

export interface GetClaimDocumentsRequest {
    claimNumber: string;
}

export interface GetClaimFinancialSummaryRequest {
    claimNumber: string;
}

export interface GetClaimFolderIdRequest {
    claimNumber: string;
}

export interface GetClaimImportantDatesRequest {
    claimNumber: string;
}

export interface GetClaimLabourCodesRequest {
    claimNumber: string;
    workPackageId: string;
}

export interface GetClaimParticipantsRequest {
    claimNumber: string;
}

export interface GetClaimPresentPositionsRequest {
    claimNumber: string;
}

export interface GetClaimTasksRequest {
    claimNumber: string;
}

export interface GetClaimWorkPackagesRequest {
    claimNumber: string;
}

export interface GetClientBrokerDetailsRequest {
    claimNumber: string;
}

export interface GetSiteVisitDetailsRequest {
    claimNumber: string;
}

export interface SearchClaimsRequest {
    query?: string;
}

export interface UpdateClaimPresentPositionRequest {
    claimNumber: string;
    updatePresentPositionRequest: UpdatePresentPositionRequest;
}

export interface UpdateClaimTaskRequest {
    claimNumber: string;
    taskId: number;
    updateTaskRequest: UpdateTaskRequest;
}

export interface UploadClaimDocumentRequest {
    claimNumber: string;
    file: Blob;
}

/**
 * 
 */
export class ClaimsApi extends runtime.BaseAPI {

    /**
     * Add an ad-hoc contact (name + email) to a claim
     */
    async addClaimAdhocContactRaw(requestParameters: AddClaimAdhocContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddAdhocContactResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling addClaimAdhocContact().'
            );
        }

        if (requestParameters['addAdhocContactRequest'] == null) {
            throw new runtime.RequiredError(
                'addAdhocContactRequest',
                'Required parameter "addAdhocContactRequest" was null or undefined when calling addClaimAdhocContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/claims/{claimNumber}/adhoc-contacts`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddAdhocContactRequestToJSON(requestParameters['addAdhocContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddAdhocContactResponseFromJSON(jsonValue));
    }

    /**
     * Add an ad-hoc contact (name + email) to a claim
     */
    async addClaimAdhocContact(requestParameters: AddClaimAdhocContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddAdhocContactResponse> {
        const response = await this.addClaimAdhocContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a claim exists by claim number
     */
    async claimExistsRaw(requestParameters: ClaimExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling claimExists().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/exists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Check if a claim exists by claim number
     */
    async claimExists(requestParameters: ClaimExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.claimExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Book time against a claim in Replicon. statusId asks for the entry to be submitted for approval; the response\'s statusId says what actually happened, which may differ. billingStatus is a separate thing, accepted but not yet stored. 409 means the day\'s timesheet is already submitted or approved and can take no more time — retrying cannot succeed.
     */
    async createClaimTimeEntryRaw(requestParameters: CreateClaimTimeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTimeEntryResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling createClaimTimeEntry().'
            );
        }

        if (requestParameters['createTimeEntryRequest'] == null) {
            throw new runtime.RequiredError(
                'createTimeEntryRequest',
                'Required parameter "createTimeEntryRequest" was null or undefined when calling createClaimTimeEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/claims/{claimNumber}/time-entries`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTimeEntryRequestToJSON(requestParameters['createTimeEntryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTimeEntryResponseFromJSON(jsonValue));
    }

    /**
     * Book time against a claim in Replicon. statusId asks for the entry to be submitted for approval; the response\'s statusId says what actually happened, which may differ. billingStatus is a separate thing, accepted but not yet stored. 409 means the day\'s timesheet is already submitted or approved and can take no more time — retrying cannot succeed.
     */
    async createClaimTimeEntry(requestParameters: CreateClaimTimeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTimeEntryResponse> {
        const response = await this.createClaimTimeEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a File Note Case Note (eform) for a claim
     */
    async createFileNoteCaseNoteRaw(requestParameters: CreateFileNoteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCaseNoteResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling createFileNoteCaseNote().'
            );
        }

        if (requestParameters['createCaseNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseNoteRequest',
                'Required parameter "createCaseNoteRequest" was null or undefined when calling createFileNoteCaseNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/claims/{claimNumber}/case-notes`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseNoteRequestToJSON(requestParameters['createCaseNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCaseNoteResponseFromJSON(jsonValue));
    }

    /**
     * Create a File Note Case Note (eform) for a claim
     */
    async createFileNoteCaseNote(requestParameters: CreateFileNoteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCaseNoteResponse> {
        const response = await this.createFileNoteCaseNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get basic claim information by claim number
     */
    async getBasicClaimInfoRaw(requestParameters: GetBasicClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasicClaimInfo>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getBasicClaimInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/claimInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasicClaimInfoFromJSON(jsonValue));
    }

    /**
     * Get basic claim information by claim number
     */
    async getBasicClaimInfo(requestParameters: GetBasicClaimInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BasicClaimInfo> {
        const response = await this.getBasicClaimInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get consolidated claim data for the details page (one call replaces claimInfo + stakeholders + claimDates + claimFinancials + siteVisit)
     */
    async getClaimRaw(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimResponseFromJSON(jsonValue));
    }

    /**
     * Get consolidated claim data for the details page (one call replaces claimInfo + stakeholders + claimDates + claimFinancials + siteVisit)
     */
    async getClaim(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimResponse> {
        const response = await this.getClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ad-hoc contacts for a claim by claim number
     */
    async getClaimAdhocContactsRaw(requestParameters: GetClaimAdhocContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdhocContactsResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimAdhocContacts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/adhoc-contacts`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdhocContactsResponseFromJSON(jsonValue));
    }

    /**
     * Get ad-hoc contacts for a claim by claim number
     */
    async getClaimAdhocContacts(requestParameters: GetClaimAdhocContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdhocContactsResponse> {
        const response = await this.getClaimAdhocContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the Replicon billing roles available to the signed-in user on a claim for a date. The date is required: send the user\'s local date, not UTC.
     */
    async getClaimBillingRolesRaw(requestParameters: GetClaimBillingRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BillingRolesResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimBillingRoles().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getClaimBillingRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/billing-roles`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingRolesResponseFromJSON(jsonValue));
    }

    /**
     * Get the Replicon billing roles available to the signed-in user on a claim for a date. The date is required: send the user\'s local date, not UTC.
     */
    async getClaimBillingRoles(requestParameters: GetClaimBillingRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BillingRolesResponse> {
        const response = await this.getClaimBillingRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all documents for a claim
     */
    async getClaimDocumentsRaw(requestParameters: GetClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentInfo>>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/documents`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentInfoFromJSON));
    }

    /**
     * List all documents for a claim
     */
    async getClaimDocuments(requestParameters: GetClaimDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentInfo>> {
        const response = await this.getClaimDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get financial summary by claim number
     */
    async getClaimFinancialSummaryRaw(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimFinancialSummary>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimFinancialSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/claimFinancials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimFinancialSummaryFromJSON(jsonValue));
    }

    /**
     * Get financial summary by claim number
     */
    async getClaimFinancialSummary(requestParameters: GetClaimFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimFinancialSummary> {
        const response = await this.getClaimFinancialSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the Box folder ID for a claim
     */
    async getClaimFolderIdRaw(requestParameters: GetClaimFolderIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimFolderId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/folder`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get the Box folder ID for a claim
     */
    async getClaimFolderId(requestParameters: GetClaimFolderIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getClaimFolderIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get important claim dates by claim number
     */
    async getClaimImportantDatesRaw(requestParameters: GetClaimImportantDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimImportantDates>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimImportantDates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/claimDates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimImportantDatesFromJSON(jsonValue));
    }

    /**
     * Get important claim dates by claim number
     */
    async getClaimImportantDates(requestParameters: GetClaimImportantDatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimImportantDates> {
        const response = await this.getClaimImportantDatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the Replicon labour codes under a work package on a claim
     */
    async getClaimLabourCodesRaw(requestParameters: GetClaimLabourCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LabourCodesResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimLabourCodes().'
            );
        }

        if (requestParameters['workPackageId'] == null) {
            throw new runtime.RequiredError(
                'workPackageId',
                'Required parameter "workPackageId" was null or undefined when calling getClaimLabourCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/work-packages/{workPackageId}/labour-codes`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))).replace(`{${"workPackageId"}}`, encodeURIComponent(String(requestParameters['workPackageId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LabourCodesResponseFromJSON(jsonValue));
    }

    /**
     * Get the Replicon labour codes under a work package on a claim
     */
    async getClaimLabourCodes(requestParameters: GetClaimLabourCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LabourCodesResponse> {
        const response = await this.getClaimLabourCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim participants (party-case roles) by claim number
     */
    async getClaimParticipantsRaw(requestParameters: GetClaimParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParticipantsResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimParticipants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/participants`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParticipantsResponseFromJSON(jsonValue));
    }

    /**
     * Get claim participants (party-case roles) by claim number
     */
    async getClaimParticipants(requestParameters: GetClaimParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParticipantsResponse> {
        const response = await this.getClaimParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the selectable present positions (current statuses) for a claim
     */
    async getClaimPresentPositionsRaw(requestParameters: GetClaimPresentPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimPresentPositions>>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimPresentPositions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/present-positions`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimPresentPositionsFromJSON));
    }

    /**
     * Get the selectable present positions (current statuses) for a claim
     */
    async getClaimPresentPositions(requestParameters: GetClaimPresentPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimPresentPositions>> {
        const response = await this.getClaimPresentPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the task list for a claim by claim number
     */
    async getClaimTasksRaw(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTasksResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimTasks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/tasks`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTasksResponseFromJSON(jsonValue));
    }

    /**
     * Get the task list for a claim by claim number
     */
    async getClaimTasks(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTasksResponse> {
        const response = await this.getClaimTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the Replicon work packages available on a claim
     */
    async getClaimWorkPackagesRaw(requestParameters: GetClaimWorkPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkPackagesResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClaimWorkPackages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/{claimNumber}/work-packages`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkPackagesResponseFromJSON(jsonValue));
    }

    /**
     * Get the Replicon work packages available on a claim
     */
    async getClaimWorkPackages(requestParameters: GetClaimWorkPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkPackagesResponse> {
        const response = await this.getClaimWorkPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get client and broker details (stakeholders) by claim number
     */
    async getClientBrokerDetailsRaw(requestParameters: GetClientBrokerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientBrokerDetailsResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getClientBrokerDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/stakeholders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientBrokerDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Get client and broker details (stakeholders) by claim number
     */
    async getClientBrokerDetails(requestParameters: GetClientBrokerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientBrokerDetailsResponse> {
        const response = await this.getClientBrokerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Recent Claims
     */
    async getRecentClaimsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimSummary>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/recent`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimSummaryFromJSON));
    }

    /**
     * Get Recent Claims
     */
    async getRecentClaims(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimSummary>> {
        const response = await this.getRecentClaimsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Whether the signed-in user is a Replicon user. The add-in shows the Time tab only when this is true. Reports false, not an error, when Replicon cannot be reached.
     */
    async getRepliconUserStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RepliconUserStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/time-entries/user-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RepliconUserStatusResponseFromJSON(jsonValue));
    }

    /**
     * Whether the signed-in user is a Replicon user. The add-in shows the Time tab only when this is true. Reports false, not an error, when Replicon cannot be reached.
     */
    async getRepliconUserStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RepliconUserStatusResponse> {
        const response = await this.getRepliconUserStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get site visit details by claim number
     */
    async getSiteVisitDetailsRaw(requestParameters: GetSiteVisitDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteVisitDetailsResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling getSiteVisitDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['claimNumber'] != null) {
            queryParameters['claimNumber'] = requestParameters['claimNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/siteVisit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteVisitDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Get site visit details by claim number
     */
    async getSiteVisitDetails(requestParameters: GetSiteVisitDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteVisitDetailsResponse> {
        const response = await this.getSiteVisitDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Time entry statuses the add-in offers. Read-only: a status follows from the approval workflow and is never set when booking time.
     */
    async getTimeEntryStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeEntryStatusesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/time-entries/statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TimeEntryStatusesResponseFromJSON(jsonValue));
    }

    /**
     * Time entry statuses the add-in offers. Read-only: a status follows from the approval workflow and is never set when booking time.
     */
    async getTimeEntryStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeEntryStatusesResponse> {
        const response = await this.getTimeEntryStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Health ping for the Outlook Add-in
     */
    async pingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Health ping for the Outlook Add-in
     */
    async ping(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pingRaw(initOverrides);
    }

    /**
     * Search claims by claim number
     */
    async searchClaimsRaw(requestParameters: SearchClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimSearchResult>>> {
        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/claims/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimSearchResultFromJSON));
    }

    /**
     * Search claims by claim number
     */
    async searchClaims(requestParameters: SearchClaimsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimSearchResult>> {
        const response = await this.searchClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a claim\'s current status and current status notes (present position)
     */
    async updateClaimPresentPositionRaw(requestParameters: UpdateClaimPresentPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePresentPositionResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling updateClaimPresentPosition().'
            );
        }

        if (requestParameters['updatePresentPositionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePresentPositionRequest',
                'Required parameter "updatePresentPositionRequest" was null or undefined when calling updateClaimPresentPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/claims/{claimNumber}/present-position`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePresentPositionRequestToJSON(requestParameters['updatePresentPositionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePresentPositionResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim\'s current status and current status notes (present position)
     */
    async updateClaimPresentPosition(requestParameters: UpdateClaimPresentPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePresentPositionResponse> {
        const response = await this.updateClaimPresentPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Put a claim task on hold: status, On Hold Until date and description
     */
    async updateClaimTaskRaw(requestParameters: UpdateClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateTaskResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling updateClaimTask().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling updateClaimTask().'
            );
        }

        if (requestParameters['updateTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTaskRequest',
                'Required parameter "updateTaskRequest" was null or undefined when calling updateClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/claims/{claimNumber}/tasks/{taskId}`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))).replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskRequestToJSON(requestParameters['updateTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTaskResponseFromJSON(jsonValue));
    }

    /**
     * Put a claim task on hold: status, On Hold Until date and description
     */
    async updateClaimTask(requestParameters: UpdateClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateTaskResponse> {
        const response = await this.updateClaimTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a document to a claim folder
     */
    async uploadClaimDocumentRaw(requestParameters: UploadClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentInfo>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling uploadClaimDocument().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadClaimDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/claims/{claimNumber}/documents`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentInfoFromJSON(jsonValue));
    }

    /**
     * Upload a document to a claim folder
     */
    async uploadClaimDocument(requestParameters: UploadClaimDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentInfo> {
        const response = await this.uploadClaimDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
